<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal w-1/2"
        role="dialog"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <header id="modal-title" class="modal-header">
          <slot name="header">
            <strong>Salvar</strong>
          </slot>
        </header>

        <section id="modal-description" class="modal-body">
          <slot name="body">
            <text-input
              v-model="formData.alias"
              label="Insira um nome para registrar seu Relatório"
              type="text"
              class="w-full"
            />
          </slot>
        </section>

        <footer class="modal-footer">
          <slot name="footer">
            <section class="flex flex-wrap">
              <button class="btn-gray ml-auto mr-3" type="button" @click="cancel">
                Cancelar
              </button>
              <button class="btn-indigo ml-3 mr-0" type="button" @click="save">
                Salvar
              </button>
            </section>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    TextInput,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      $this: this,
      get formData() {
        return this.$this.$parent.report ?? { form: null, results: null, alias: '' }
      },
    }
  },
  methods: {
    save() {
      this.formData.post(this.route('indicators.report'), { onSuccess: () => this.cancel() })
    },
    cancel() {
      this.$emit('close')
    },
  },
}
</script>
